import { Box, Stack } from "@mui/material";
import { useApp, useTheme } from "contexts";
import { Custom, Field } from "components";
import { ICategory, IMenu } from "interfaces";
import { useMenu } from "components/field/menu";

// icons
import { AddRounded, CloseRounded, RemoveRounded } from "@mui/icons-material";

type Props = {
  createdBy?: string;
  menu: IMenu[];
  hasError?: boolean;
  onUpdate?: (menu: IMenu[]) => void;
};

export const Create = ({
  createdBy,
  hasError = false,
  menu,
  onUpdate,
}: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();

  const {
    user,
    menuData,
    configurations,
    handleSelect,
    handleDelete,
    handleAddItem,
    handleRemoveItem,
    handleChange,
    handleCounterChange,
  } = useMenu(menu, false, createdBy, onUpdate);

  return (
    <Box>
      <Stack spacing={theme.spacing.md}>
        <Field.Search
          autoReset
          hasError={hasError}
          onOptionSelect={handleSelect}
          label={t.component.field.menu.search}
          options={configurations}
        />

        {menuData.map((menu: IMenu, i: number) => {
          return (
            <Stack
              key={i}
              sx={{
                border: 1,
                px: theme.spacing.lg,
                py: theme.spacing.sm,
                borderRadius: theme.border.radius,
                borderColor: theme.color.border.accent,
              }}
            >
              <Box mt={theme.spacing.md}>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={theme.spacing.md}
                  justifyContent="space-between"
                >
                  <Custom.Typography
                    size={theme.font.sm}
                    weight={theme.font.semiBold}
                  >
                    {i + 1}. {menu.configuration.name}
                  </Custom.Typography>
                  <Custom.IconButton
                    size="small"
                    onClick={() => handleDelete(menu.configuration._id)}
                  >
                    <CloseRounded />
                  </Custom.IconButton>
                </Stack>
              </Box>
              <Box mt={theme.spacing.md}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Custom.Typography size={theme.font.sm}>
                    {t.component.field.menu.count}
                  </Custom.Typography>

                  <Field.Counter
                    min={1}
                    value={menu.count}
                    onChange={(counter: number) =>
                      handleCounterChange(counter, i)
                    }
                  />
                </Stack>
              </Box>
              <Box mt={theme.spacing.md}>
                <Stack spacing={theme.spacing.sm}>
                  {menu.categories.map((category: ICategory, j: number) => (
                    <Stack
                      key={category._id}
                      direction="row"
                      alignItems="center"
                      gap={theme.spacing.sm}
                    >
                      <Custom.Typography>{j + 1}.</Custom.Typography>
                      <Custom.TextField
                        size="small"
                        required
                        disabled={category.readonly}
                        placeholder={t.placeholder.menu_category}
                        defaultValue={category.name}
                        onBlur={(e) =>
                          handleChange(i, category._id, e.target.value)
                        }
                        sx={{ flex: 1 }}
                      />
                      <Custom.IconButton
                        onClick={() => handleRemoveItem(i, category._id)}
                      >
                        <RemoveRounded />
                      </Custom.IconButton>
                    </Stack>
                  ))}
                  <Box>
                    <Custom.Button secondary onClick={() => handleAddItem(i)}>
                      <AddRounded />
                    </Custom.Button>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};
